import $ from 'jquery';
import ClipList from './clip-list';
import * as events from './events';
import defaultConfigs from './default-configs';

export default $.extend(ClipList, {
  events,
  create(opts) {
    return new ClipList($.extend({}, defaultConfigs, opts));
  }
});


/** WEBPACK FOOTER **
 ** ./src/VO2/libs/clip-list/index.js
 **/